import {defineComponent, onBeforeMount, ref} from "vue";
import {useInvoicingStore} from "@/app/stores/invoicing-store.ts";
import {storeToRefs} from "pinia";
import type {InvoiceRoundDto} from "@/api/enterprise-gateway-api.proxy.ts";
import {useFormatting} from "@/composables/currency-format.ts";

export default defineComponent({
    name: 'AegInvoiceRoundTab',
    setup() {
        const {formatDateTime, formatDate} = useFormatting();
        const emptyState = ref<boolean>(false);
        const invoiceStore = useInvoicingStore();
        const invoiceRounds = ref<InvoiceRoundDto[]>([]);
        const {isLoading} = storeToRefs(invoiceStore);

        const loadInvoiceRounds = async () => {
            emptyState.value = false;
            const result = await invoiceStore.loadInvoiceRounds();
            if (result) {
                invoiceRounds.value = result.items;
                emptyState.value = result.items.length === 0;
            }
        }

        onBeforeMount(async () => {
            await loadInvoiceRounds();
        })

        return {
            formatDateTime,
            formatDate,
            invoiceRounds,
            isLoading,
            emptyState
        }
    }
});